module.exports = __webpack_public_path__ + "dcdb70a34a0081534b533d7fc77be3db.svg";